import { useTranslation } from "react-i18next";

interface Props {
  type:
    | "area"
    | "distance"
    | "engineDisplacement"
    | "enginePower"
    | "euro"
    | "million"
    | "nettoPoints"
    | "photovoltaicPower"
    | "percentage"
    | "piece"
    | "volume"
    | "kg"
    | "g";
}

export const InputAddon = ({ type }: Props) => {
  const { t } = useTranslation();

  switch (type) {
    case "area":
      return (
        <span>
          m<sup>2</sup>
        </span>
      );
    case "engineDisplacement":
      return (
        <span>
          cm<sup>3</sup>
        </span>
      );
    case "percentage":
      return <span>%</span>;
    case "volume":
      return (
        <span>
          m<sup>3</sup>
        </span>
      );
    default:
      return <span className="nowrap">{t("common.sign." + type)}</span>;
  }
};
